import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import XCloseIco from "../../../../../assets/icons/XCloseIco";

const DialogCandidateHub = ({
  open,
  handleClose,
  footer,
  content,
  title,
  icon,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
        },
      }}
    >
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <div>{icon}</div>
        <Button onClick={handleClose}>
          <XCloseIco />
        </Button>
      </DialogActions>
      <DialogTitle>
        <Typography variant="h3">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="p" fontSize={"15px"}>
          {content}
        </Typography>

        {footer}
      </DialogContent>
    </Dialog>
  );
};

export default DialogCandidateHub;
